import { useState, useEffect } from 'react';
import { React, useNavigate } from '../../../imports/generalImport';
import { Box, Container, TextField, InputAdornment, IconButton } from '../../../imports/muiImport';
import styles from './MobileHomeSearch.module.css';
import { SearchIcon } from 'lucide-react';

function MobileHomeSearch() {
  const navigate = useNavigate();
  const [placeholder, setPlaceholder] = useState('');
  const [textIndex, setTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentText = suggestions?.[textIndex];
    let typingSpeed = isDeleting ? 40 : 100;

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setPlaceholder(currentText?.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);

        if (charIndex + 1 === currentText?.length) {
          setTimeout(() => setIsDeleting(true), 1500);
        }
      } else {
        setPlaceholder(currentText?.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);

        if (charIndex === 0) {
          setIsDeleting(false);
          setTextIndex((prev) => (prev + 1) % suggestions?.length);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, textIndex]);

  return (
    <Container sx={{ pt: '2px' }}>
      <Box>
        <TextField
          id="outlined-basic"
          variant="outlined"
          fullWidth
          placeholder={placeholder}
          onClick={() => navigate('/search')}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 8,
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: 8,
            },
          }}
          InputProps={{
            classes: {
              input: styles.inputField,
            },
            startAdornment: (
              <InputAdornment position="start">
                <IconButton size="large" edge="start">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </Container>
  );
}

export default MobileHomeSearch;

const suggestions = [
  'Search brand vouchers  and deals',
  'Find gift cards by category',
  'Explore trending vouchers ',
  'Search for electronics discounts',
  'Find fashion deals',
  'Discover best offers today',
  'Search gift cards for food',
  'Find entertainment vouchers',
  'Search travel gift cards',
  'Search gaming gift cards',
  'Find apparel and fashion vouchers ',
  'Get daily shopping deals',
  'Search vouchers  by store name',
  'Find promo codes quickly',
];
